// LICENSE : MIT
"use strict";
import ToggleAndDisplayPattern from "./ToggleAndDisplayPattern";
import ToggleAndPattern from "./ToggleAndPattern";
import ToggleOrPattern from "./ToggleOrPattern";
module.exports = {
    // default: or pattern
    TogglePattern: ToggleOrPattern,
    ToggleAndDisplayPattern,
    ToggleOrPattern,
    ToggleAndPattern
};